export default __webpack_public_path__ + "static/media/order-status.9feb9813.svg";